'use client'

import dynamic from 'next/dynamic'

const DistinctiveFactorsChartAverage = dynamic(() => import('./DistinctiveFactorsChartAverage'), { ssr: false })

export default DistinctiveFactorsChartAverage
